/* eslint-disable @typescript-eslint/no-explicit-any */
// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig } from '@hey-api/client-axios';
export const client = createClient(createConfig());
/**
 * Admin-only: list all inquiries, newest first, with their selected
 * interest types eagerly loaded so no N+1 query happens on serialization.
 */
export const getInquiries = (options) => {
    return (client).get({
        ...options,
        url: '/inquiries/'
    });
};
/**
 * Public: create a new inquiry from the contact form. Resolves the
 * submitted interest_type_ids into InquiryType rows and assigns them to
 * the relationship — SQLAlchemy handles the inquiry_interest join-table
 * inserts automatically on commit.
 * Rate-limited to 5 submissions/hour per IP (generous for a real
 * client, well below what a scripted flood would attempt) and gated by
 * a honeypot field — a hidden form field real users never fill in,
 * which bots that auto-fill every input do. A honeypot hit is accepted
 * and returns a normal-looking response (so scrapers get no signal
 * they were caught) but is never actually saved.
 */
export const postInquiries = (options) => {
    return (client).post({
        ...options,
        url: '/inquiries/'
    });
};
/**
 * Admin-only: fetch a single inquiry with its interests.
 */
export const getInquiriesByInquiryId = (options) => {
    return (client).get({
        ...options,
        url: '/inquiries/{inquiry_id}'
    });
};
/**
 * Public: list active inquiry types in display order — used to
 * render the contact form's checkboxes.
 */
export const getInquiryTypes = (options) => {
    return (client).get({
        ...options,
        url: '/inquiry-types/'
    });
};
/**
 * Admin-only: list all galleries, newest first.
 */
export const getGalleries = (options) => {
    return (client).get({
        ...options,
        url: '/galleries/'
    });
};
/**
 * Admin-only: create a new (unpublished) gallery.
 */
export const postGalleries = (options) => {
    return (client).post({
        ...options,
        url: '/galleries/'
    });
};
/**
 * Admin-only: fetch one gallery with its photos.
 */
export const getGalleriesByGalleryId = (options) => {
    return (client).get({
        ...options,
        url: '/galleries/{gallery_id}'
    });
};
/**
 * Admin-only: partial update of a gallery — only the fields present
 * in the request body are changed. This is what backs the
 * published/draft toggle: PATCH {"is_published": true}.
 */
export const patchGalleriesByGalleryId = (options) => {
    return (client).patch({
        ...options,
        url: '/galleries/{gallery_id}'
    });
};
/**
 * Admin-only: upload one or more photos and link them to this
 * gallery. Expects multipart/form-data with one or more files under
 * the 'photos' field — not JSON, since this is a file upload.
 * For each file: saves the original as the high-res download
 * derivative, generates a resized copy as the web-viewing derivative,
 * and records both storage keys on a new Photo row.
 */
export const postGalleriesByGalleryIdPhotos = (options) => {
    return (client).post({
        ...options,
        url: '/galleries/{gallery_id}/photos'
    });
};
/**
 * Serve an uploaded photo by its storage key.
 * Admin-only for now (login_required), since client galleries don't have
 * their own login/access-control yet. Once client auth exists, this route
 * needs a real rewrite: check that the requesting client actually owns the
 * gallery the photo belongs to (or that the gallery is published and the
 * client is authenticated for it), rather than just checking "is someone
 * logged in as admin". Don't ship this as-is once client-facing galleries
 * go live — it currently has no per-gallery access control at all beyond
 * the admin session check.
 *
 * The path-traversal guard below matters because storage_key comes
 * straight from the URL: without resolving and checking it against
 * upload_root(), a request like /media/../../etc/passwd would otherwise
 * be servable.
 */
export const getMediaByStorageKey = (options) => {
    return (client).get({
        ...options,
        url: '/media/{storage_key}'
    });
};
